import Vue from "vue";
import ElementUI, { Dialog, Drawer } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AppPagination from "@/components/AppPagination.vue";
import PortalIcon from "@/components/portal/PortalIcon.vue";
import PortalMarketingHero from "@/components/portal/PortalMarketingHero.vue";

// 新增/编辑弹窗：仅取消、右上角 X 可关闭，避免误点遮罩导致未保存内容丢失
Dialog.props.closeOnClickModal.default = false;
// 章节等表单抽屉同理；门户导航/播放页抽屉在组件内显式开启 wrapper-closable
Drawer.props.wrapperClosable.default = false;

Vue.use(ElementUI);
Vue.component("AppPagination", AppPagination);
Vue.component("PortalIcon", PortalIcon);
Vue.component("PortalMarketingHero", PortalMarketingHero);
Vue.config.productionTip = false;

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    const m = r && r.message;
    if (
      (r && r.silent) ||
      (m && /Navigation (duplicated|cancelled)|Avoided redundant navigation/i.test(m))
    ) {
      e.preventDefault();
    }
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
